import { Request, Success, NetworkAction } from "../../actions";
import Organization from "models/organization";

/**
 * GetOneSuccess
 * @constructor GetOneSuccess
 *
 * @extends Success
 *
 * @param {Object} spec - Unused parameter
 * @param {Object} [my] - Protected properties holder
 */
export class GetOneSuccess extends Success {
	constructor(spec, ...rest) {
		super(spec, ...rest);

		this.type = "Organization/GetOne/Success";
	}

	performOrganizationReducer(state) {
		const { data } = this.payload();
		const organization = new Organization(data);

		return {
			...state,
			isLoading: false,
			organization
		};
	}
}

/**
 * GetOneRequest
 * @constructor GetOneRequest
 *
 * @extends Request
 *
 * @param {Object} spec - Unused parameter
 * @param {Object} [my] - Protected properties holder
 */
export class GetOneRequest extends Request {
	constructor(spec, ...rest) {
		super(spec, ...rest);

		this.type = "Organization/GetOne/Request";
	}

	performOrganizationReducer(state) {
		return {
			...state,
			isLoading: true
		};
	}
}

/**
 * @constructor GetOne
 * @extends NetworkAction
 */
export default class GetOne extends NetworkAction {
	constructor(organizationId) {
		super(...arguments); // eslint-disable-line prefer-rest-params

		this.type = "Organization/GetOne";

		this._endpoint = `/bo/organizers/${organizationId}/`;

		this._actions = Object.assign({}, this._actions, {
			request: GetOneRequest,
			success: GetOneSuccess
		});
	}
}
